// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1442":"55108997","1760":"2074fe10","2326":"2074fe10","4136":"55108997","6100":"073ed021","7456":"073ed021","8506":"2b17ca99","8822":"55108997","8917":"55108997"}[chunkId] + ".chunk.css";
};